export default "__VITE_ASSET__BOPyhlWI__"